/* eslint-disable default-case */
import React from "react";
import "./teamCard.css";
// import cameronImg from "../../../assets/team/cameron.png";
// import markusImg from "../../../assets/team/markus.jpg";
import klasImg from "../../../assets/team/klas.webp";
import williamImg from "../../../assets/team/william.webp";

export default function TeamCard({
  memberImg,
  firstname,
  lastname,
  role,
  description,
  imgAlt,
}) {
  let teamImage;

  switch (memberImg) {
    case "klas":
      teamImage = klasImg;
      break;

    case "william":
      teamImage = williamImg;
      break;
  }

  return (
    <div className={`team-container`}>
      <div className="about-us-team-member">
        <img src={teamImage} alt={imgAlt} width={250} height={250} />
        <h4>
          {firstname} {lastname}
        </h4>
        <h5>{role}</h5>
        <p>{description}</p>
      </div>
    </div>
  );
}
